import { z } from 'zod';

import { MatterLanguage } from '../../../../../../../backend/src/types/types';

export const makeBasicInfoSchema = (requireCode: boolean) =>
  z.object({
    name: z.string().trim().min(1, { message: 'Matter name must be provided' }),
    code: requireCode ? z.string().trim().min(1, { message: 'Matter code is required' }) : z.string().optional(),
    tokenLimit: z.number().optional(),
    language: z.enum(MatterLanguage),
  });

export type BasicInfoForm = z.infer<ReturnType<typeof makeBasicInfoSchema>>;
